import axios from "axios";
import config from "./config";

export const forgotPassword = (body) => {
  return axios.post("/forgot-password", body, config);
}